import { useState } from 'react';
import { Input } from '../../components/ui/Input';
import { Button } from '../../components/ui/Button';
import type { User } from '../../types';
import { getUserByEmail } from '../../services/storage';

interface UserFormProps {
  onSubmit: (userData: Omit<User, 'id' | 'createdAt'>) => void;
  onCancel: () => void;
}

export const UserForm = ({ onSubmit, onCancel }: UserFormProps) => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [role, setRole] = useState<'admin' | 'client'>('client');
  const [companyId, setCompanyId] = useState('');
  const [errors, setErrors] = useState<{ name?: string; email?: string }>({});

  const validateEmail = (email: string) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    
    const newErrors: { name?: string; email?: string } = {};

    if (!name.trim()) {
      newErrors.name = 'Nome é obrigatório';
    }

    if (!email.trim()) {
      newErrors.email = 'Email é obrigatório';
    } else if (!validateEmail(email)) {
      newErrors.email = 'Email inválido';
    } else {
      const existingUser = getUserByEmail(email);
      if (existingUser) {
        newErrors.email = 'Email já cadastrado';
      }
    }

    setErrors(newErrors);

    if (Object.keys(newErrors).length === 0) {
      onSubmit({
        name: name.trim(),
        email: email.trim(),
        role,
        companyId: role === 'client' ? companyId.trim() || undefined : undefined,
        status: 'active'
      });
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <Input
        label="Nome *"
        placeholder="Nome completo do usuário"
        value={name}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setName(e.target.value)}
        error={errors.name}
      />

      <Input
        label="Email *"
        type="email"
        placeholder="email@exemplo.com"
        value={email}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setEmail(e.target.value)}
        error={errors.email}
      />

      <div>
        <label className="block text-sm font-medium text-neutral-700 mb-1.5">
          Função *
        </label>
        <select
          value={role}
          onChange={(e: React.ChangeEvent<HTMLSelectElement>) => setRole(e.target.value as 'admin' | 'client')}
          className="w-full h-11 px-4 rounded-lg border border-neutral-200 bg-white focus:outline-none focus:ring-2 focus:ring-primary-blue/50 focus:border-primary-blue transition-all"
        >
          <option value="client">Cliente</option>
          <option value="admin">Admin</option>
        </select>
      </div>

      {role === 'client' && (
        <Input
          label="Empresa ID (opcional)"
          placeholder="ID da empresa"
          value={companyId}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => setCompanyId(e.target.value)}
        />
      )}

      <div className="flex gap-3 pt-4">
        <Button
          type="button"
          variant="outline"
          onClick={onCancel}
          className="flex-1"
        >
          Cancelar
        </Button>
        <Button
          type="submit"
          variant="primary"
          className="flex-1"
        >
          Criar Usuário
        </Button>
      </div>
    </form>
  );
};